import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  iconButtonColor: {
    marginLeft: 30,
    color: theme.palette.neutralDark,
  },
  textAreaField: {
    '& textarea': {
      minHeight: 100,
    },
  }
}));
